import React from 'react'
import { Redirect, Route } from 'react-router-dom'

const adminPages = [
  '/home/users',
  '/home/groups',
  '/home/clients',
  '/home/eye-of-sauron',
  '/home/masive-upload-client',
  '/home/reports'
]

export const PrivateRoute = ({ component: Component, authed, path, ...rest }) => (
  <Route
    {...rest}
    render={props => authed && (authed.role === 'admin' || authed.clientRole === 'admin')
      ? (<Component {...props} />)
      : authed && adminPages.find(r => r === rest.location.pathname)
        ? (<Redirect
          to={{
            pathname: '/logout',
            state: {
              from: props.location
            }
          }} />)
        : authed && !adminPages.find(r => r === rest.location.pathname)
          ? (<Component {...props} />)
          : (<Redirect
            to={{
              pathname: '/logout',
              state: {
                from: props.location
              }
            }} />)
    }
  />
)